import React from 'react';
import { css } from 'linaria';
import { CubeIcon, NotePencilIcon, RulerIcon, TruckIcon } from '@fronton/icons-react';
import {
  ReviewsSection,
  ButtonWithGAClickButton,
  Typography,
  ReviewsBenefits,
} from 'common/components';
import { WINDOWS_ELEMENT_BLOCK } from '../../windows-constants';
import { WindowsBrands } from '../windows-brands';

const reviewLink = css`
  &&& {
    padding: 0;
    border-bottom: 2px solid var(--control-accent);

    &:hover {
      background-color: unset;
    }
  }
`;

export const WindowsReviews: React.FC<{ onConsultationSignupBtnClick: TFunction, regionId: string; }> = (
  { onConsultationSignupBtnClick, regionId }
) => (
  <ReviewsSection
    benefits={
      <ReviewsBenefits
        benefitsList={[
          {
            icon: RulerIcon,
            text: 'Сделаем\nточный замер',
          },
          {
            icon: CubeIcon,
            text: 'Подготовим\nбесплатный проект',
          },
          {
            icon: NotePencilIcon,
            text: 'Оформим заказ\nонлайн или офлайн',
          },
          {
            icon: TruckIcon,
            text: 'Доставим\nи\u00A0установим окна',
          },
        ]}
      />
    }
    description="Делаем окна, которые хочется показывать"
    review={
      <WindowsBrands regionId={regionId} />
    }
    showReviewTitle={false}
    title={
      <>
        <ButtonWithGAClickButton
          className={reviewLink}
          elementBlock={`${WINDOWS_ELEMENT_BLOCK} / Reviews`}
          elementName="Отзывы клиентов"
          elementText="Запишитесь"
          onClick={onConsultationSignupBtnClick}
          title="Запишитесь на проектирование"
        >
          <Typography variant="h2" color="text-invert">
            Запишитесь
          </Typography>
        </ButtonWithGAClickButton>{' '}
        на&nbsp;бесплатную консультацию
        <Typography color="text-invert" variant="l" size="body_long">
          Ваш персональный менеджер позаботится о всех этапах проекта
        </Typography>
      </>
    }
  />
);
